export default __webpack_public_path__ + "static/media/exit.07d98d42.svg";